import { useMemo } from 'react';
import { getMapElementsBounds } from 'design-system/atoms/custom-google-map/utils';
import { wktToPointArray } from '@lib/gis';
import { useNavigate } from 'react-router-dom';
import BusRoutesSetupWizard, {
  BusMonitoringSegment,
} from '../BusRoutesSetupWizard';
import { useCurrentSiteData } from '../../data/useSiteData';
import Spinner from '../Spinner';
import { pathSiteMonitoringPerformancePublicTransport } from '../../router/utils/path';
import { useContextSite } from '../../router/context/ContextSite';
import { useSiteBusSegmentsData } from '../../data/useSiteBusSegmentsData';

export default function CreateBusSegment() {
  const { orgId, siteId } = useContextSite();
  const currentSiteDataHandler = useCurrentSiteData();
  const siteBusSegmentsDataHandler = useSiteBusSegmentsData({ siteId });
  const navigate = useNavigate();

  const initialMapBounds = useMemo(() => {
    if (!currentSiteDataHandler.data) {
      return undefined;
    }
    const elements = [
      ...(currentSiteDataHandler.data?.location
        ? [currentSiteDataHandler.data.location]
        : []),
      ...(currentSiteDataHandler.data?.routes
        .filter(
          (r): r is typeof r & { wkt: string } => typeof r.wkt === 'string'
        )
        .flatMap((r) => wktToPointArray(r.wkt)) ?? []),
    ];
    return getMapElementsBounds(elements);
  }, [currentSiteDataHandler.data]);

  if (!initialMapBounds) {
    return <Spinner />;
  }
  return (
    <BusRoutesSetupWizard
      onSave={async (segment: BusMonitoringSegment, searchArea: string) => {
        await siteBusSegmentsDataHandler.createBusRouteSegmentArea({
          name: segment.name || 'New Monitoring Area',
          areaWkt: searchArea,
          busRouteSegments: segment.busRouteSegments,
        });
        navigate(
          pathSiteMonitoringPerformancePublicTransport({
            orgId,
            siteId,
          })
        );
      }}
      onCancel={() => {
        navigate(
          pathSiteMonitoringPerformancePublicTransport({
            orgId,
            siteId,
          })
        );
      }}
      initialMapBounds={{
        north: initialMapBounds.ne.lat,
        south: initialMapBounds.sw.lat,
        east: initialMapBounds.ne.lng,
        west: initialMapBounds.sw.lng,
      }}
    />
  );
}
